import { MutationTree } from 'vuex'
import { MutationTypesContractor } from '@/store/contractors/mutations-types'
import { ContractorState } from './state'
import { Contractor } from '@/interfaces/contractor'

export type Mutations<S = ContractorState> = {
    [MutationTypesContractor.SET_CONTRACTOR](state: S, payload: Contractor): void
    [MutationTypesContractor.SET_REVIEW_CONTRACTOR](state: S, payload: Contractor): void
}

export const mutations: MutationTree<ContractorState> & Mutations = {
    [MutationTypesContractor.SET_CONTRACTOR](state, payload: Contractor) {
        state.current = payload
    },
    [MutationTypesContractor.SET_CONTRACTORS](state, payload: Contractor[]) {
        state.list = payload
    },
    [MutationTypesContractor.SET_REVIEW_CONTRACTOR](state, payload: Contractor) {
        state.reviewContractor = payload
    },
}